import { Input, Select } from '@/components/ui'
// Селектор активного клуба в шапке. Виден ролям БЕЗ своего клуба (super_admin и
// кросс-клубные support/manager из Help): конфигурация привязана к клубу, поэтому
// клуб выбирается явно. Клубный сотрудник клуб не выбирает — он выводится из JWT.

import { useClubContext } from '@/context/ClubContext'

export function ClubSwitcher(): React.JSX.Element | null {
  const { isCrossClub, clubId, setClubId, clubs, clubsLoading, clubsError } = useClubContext()

  if (!isCrossClub) return null

  return (
    <div className="club-switcher">
      <span className="club-switcher__label">Клуб</span>
      {clubsLoading ? (
        <span className="muted" style={{ fontSize: 13 }}>
          загрузка…
        </span>
      ) : clubs.length > 0 ? (
        <Select
          value={clubId ?? ''}
          onChange={(e) => setClubId(e.target.value || null)}
          aria-label="Выбрать клуб"
        >
          <option value="">— выберите клуб —</option>
          {clubs.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </Select>
      ) : (
        // Фолбэк, если список клубов недоступен — ручной ввод UUID.
        <Input
          type="text"
          value={clubId ?? ''}
          onChange={(e) => setClubId(e.target.value.trim() || null)}
          placeholder={clubsError ? 'UUID клуба' : 'нет клубов'}
          aria-label="UUID клуба"
        />
      )}
    </div>
  )
}
